import { TSharedBetSlipResponse } from "@api-types/quick-play/SharedBetSlipDto";
import { Lookup } from "@data-types";
import { httpClient } from "@utils";
import { getApiRequestContext } from "@utils/api-config";
import { getApplicationRequestHeaders } from "@utils/api-config/getApplicationRequestHeader";
import { ApiRequestContextData } from "@utils/api-config/types";

export default class BetSlipSharesApiService {
	static baseUrl(context: ApiRequestContextData) {
		return `${WEBPACK_BASE_ADDRESS}${context.agencyKey}/bet-slip-shares`;
	}

	static getRequestHeaders = (context: ApiRequestContextData) => {
		const appHeaders = getApplicationRequestHeaders(context);
		appHeaders["Content-Type" as keyof HeadersInit] = "application/json";
		return appHeaders;
	};

	static async fetchAllSharedBetSlips(): Promise<
		Lookup<TSharedBetSlipResponse>
	> {
		const context = getApiRequestContext();
		return await httpClient.get(
			`${this.baseUrl(context)}/fetch-all/?rpp=50&page=1&translate=true`,
			this.getRequestHeaders(context)
		);
	}

	static async insertSharedBetSlip(
		betSlipId: string,
		betSlipShareType: number
	): Promise<void> {
		const context = getApiRequestContext();
		const url = `${this.baseUrl(context)}/insert/${betSlipId}?betSlipSharedType=${betSlipShareType}`;

		return await httpClient.get(url, this.getRequestHeaders(context));
	}
}
